module.exports = __webpack_public_path__ + "static/media/web-portal-badge@3x.dd5e9c16.png";